module.exports = __webpack_public_path__ + "img/vc_dark.b5f438b1.svg";